import { libConfig } from '../config';
import { validators } from '../utils/validator';
export var hide = function (element, _a) {
    var _b = _a.miliseconds, miliseconds = _b === void 0 ? 1000 : _b, onAnimationStart = _a.onAnimationStart, onAnimationEnd = _a.onAnimationEnd;
    if (validators.isHidden(element)) {
        return;
    }
    element.setAttribute(libConfig.tag, libConfig.values.hidden);
    onAnimationStart === null || onAnimationStart === void 0 ? void 0 : onAnimationStart(element);
    element.style.overflow = 'hidden';
    var animationRef = element.animate([{ height: "".concat(element.offsetHeight, "px") }, { height: '0px' }], { duration: miliseconds });
    animationRef.addEventListener('finish', function () {
        element.style.overflow = '';
        element.style.display = 'none';
        onAnimationEnd === null || onAnimationEnd === void 0 ? void 0 : onAnimationEnd(element);
    });
};
//# sourceMappingURL=hide.js.map